export default "__VITE_ASSET__Drf9d211__"